class Script {
  source

  constructor (source) {
    window.pageScripts = window.pageScripts ?? { eventListeners: [] }
    this.source = source
  }

  render (page, pageEl) {
    if (!this.source) return

    this.#removePageListeners(page)

    const inlineScript = document.createElement('script')
    inlineScript.setAttribute('type', 'text/javascript')
    inlineScript.innerHTML = this.source.replaceAll('PAGE_ID', page._id)
    pageEl.appendChild(inlineScript)
    window.pageScripts[page._id]?.init(page, pageEl)
  }

  #removePageListeners (page) {
    if (!window.pageScripts.eventListeners) return

    window.pageScripts.eventListeners = window.pageScripts.eventListeners.filter((item) => {
      if (item.page._id === page._id) {
        const options = !!item.useCapture
        item.element?.removeEventListener(item.eventType, item.callback, options)
        item.elements?.forEach((el) => el.removeEventListener(item.eventType, item.callback, options))
        return false
      }
      return true
    })
  }
}

export { Script }
